var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('w-button',_vm._g({attrs:{"rounded":_vm.rounded || _vm.circle,"size":_vm.size,"icon":_vm.icon,"icon-right":_vm.iconRight,"color":_vm.color,"disabled":!_vm.enabled,"loading":_vm.loading},on:{"click":_vm.copyLink}},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.$t('copyWeetButton.link'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }